import { cEl } from '../../../util';
import hospitalView from '../../../assets/images/home/background-hospital-view.webp';
import doctor from '../../../assets/images/home/background-doctor.webp';
import robot from '../../../assets/images/home/background-robot.webp';
import leftArrow from '../../../assets/images/home/home-left-arrow.svg';
import rightArrow from '../../../assets/images/home/home-right-arrow.svg';
import HomeSlide from './HomeSlide';
import { navigateTo } from '../../AppHeader/Link';
import { PATH_LEARN, PATH_TEST } from '../../path';

const ANIMATION_TIME = 700;
const ANIMATION_INTERVAL_TIME = 4000;

function Home(parent) {
    const homeContainer = cEl('div');
    homeContainer.classList.add('home-container');

    const carouselContainer = cEl('div');
    carouselContainer.classList.add('carousel-container');

    const gradientContainer = cEl('div');
    gradientContainer.classList.add('gradient-container');
    const leftGradient = cEl('div');
    leftGradient.classList.add('gradient-box', 'left-gradient');
    const rightGradient = cEl('div');
    rightGradient.classList.add('gradient-box', 'right-gradient');
    gradientContainer.append(leftGradient, rightGradient);

    const carousel = cEl('div');
    carousel.classList.add('carousel');

    const slides = [
        HomeSlide({
            src: hospitalView,
            name: 'hospital-view',
            imgStyle: {
                'backdrop-filter': 'blur(3px)',
            },
            title: `365일 24시간<br>병원은 불이 꺼지지 않는 곳`,
            description: `병원의 주말, 야간 근무는 일상이지만 누구도 선뜻 나서기 어려운 시간입니다.<br>그럴 때 묵묵히 곁에서 단순 업무를 덜어주고 인력이 부족할 때 힘이 되어주는<br>서비스 로봇이 가장 필요한 곳, 바로 병원입니다.`,
        }),
        HomeSlide({
            src: doctor,
            name: 'doctor',
            imgStyle: {
                'backdrop-filter': 'blur(3px)',
            },
            title: `사람 대신 로봇을 써야하는<br>이유가 있나요?`,
            description: `사람이 로봇보다 다양한 업무를 해낼 수 있습니다. 그러나 병원 인력의 이직률은<br>매우 높습니다. 로봇은 업무 지시를 하기만 하면 잠을 자지도 않고 단순 반복<br>업무를 하며, 함께하는 사람을 기다려주는 미덕도 가지고 있습니다.`,
        }),
        HomeSlide({
            src: robot,
            name: 'robot',
            imgStyle: {
                'backdrop-filter': 'blur(5px)',
            },
            title: `병원 서비스 로봇은<br>어떤 역할을 하나요?`,
            description: `병원에서 로봇이라고 하면 수술 혹은 재활 로봇을 떠올리지만,<br>‘서비스 로봇’은 단순 반복 작업을 대신하여 의료진이 더욱 중요한 업무에<br>집중할 수 있도록 돕습니다.`,
        }),
    ];

    carousel.append(...slides);

    const controls = cEl('div');
    controls.classList.add('controls');

    const prevButton = cEl('button');
    prevButton.classList.add('button', 'prev-button');
    const prevImg = cEl('img');
    prevImg.src = leftArrow;
    prevImg.alt = 'left arrow';
    prevButton.appendChild(prevImg);

    const nextButton = cEl('button');
    nextButton.classList.add('button', 'next-button');
    const nextImg = cEl('img');
    nextImg.src = rightArrow;
    nextImg.alt = 'right arrow';
    nextButton.appendChild(nextImg);

    controls.append(prevButton, nextButton);

    carouselContainer.append(carousel, gradientContainer, controls);

    let currentIndex = 2; // 시작 위치는 복제된 첫 번째 슬라이드 뒤
    const slideWidth = 800 + 80; // 슬라이드 너비 + gap

    // 초기화: 슬라이드 복제
    function setupCarousel() {
        const firstClone = slides[0].cloneNode(true);
        const secondClone = slides[1].cloneNode(true);
        const thirdClone = slides[2].cloneNode(true);

        // 복제 슬라이드를 앞뒤로 추가
        carousel.append(firstClone);
        carousel.prepend(thirdClone);
        carousel.prepend(secondClone);

        // 초기 위치 설정
        carousel.style.transform = `translateX(${(window.innerWidth - slideWidth) / 2 - slideWidth * currentIndex + 40}px)`;
    }
    setupCarousel();

    function movePrevCarousel(index) {
        prevButton.disabled = true;
        animateWithTransition(
            carousel,
            {
                transform: `translateX(${(window.innerWidth - slideWidth) / 2 - slideWidth * index + 40}px)`,
            },
            ANIMATION_TIME,
            () => {
                requestAnimationFrame(() => {
                    const currentSlides = Array.from(carouselContainer.querySelectorAll('.carousel-slide'));
                    const lastNode = currentSlides[currentSlides.length - 1];
                    if (lastNode) {
                        const cloneNode = lastNode.cloneNode(true);
                        carousel.removeChild(lastNode);
                        carousel.prepend(cloneNode);
                        carousel.style.transform = `translateX(${(window.innerWidth - slideWidth) / 2 - slideWidth * (index + 1) + 40}px)`;

                        currentIndex = 2;
                    }
                    prevButton.disabled = false;
                });
            },
        );
    }

    function moveNextCarousel(index) {
        nextButton.disabled = true;
        animateWithTransition(
            carousel,
            {
                transform: `translateX(${(window.innerWidth - slideWidth) / 2 - slideWidth * index + 40}px)`,
            },
            ANIMATION_TIME,
            () => {
                requestAnimationFrame(() => {
                    const currentSlides = Array.from(carouselContainer.querySelectorAll('.carousel-slide'));
                    const firstNode = currentSlides[0];

                    if (firstNode) {
                        const cloneNode = firstNode.cloneNode(true);
                        carousel.removeChild(firstNode);
                        carousel.append(cloneNode);
                        carousel.style.transform = `translateX(${(window.innerWidth - slideWidth) / 2 - slideWidth * (index - 1) + 40}px)`;

                        currentIndex = 2;
                    }
                    nextButton.disabled = false;
                });
            },
        );
    }

    // 버튼 이벤트
    prevButton.addEventListener('click', () => {
        currentIndex--;
        movePrevCarousel(currentIndex);
    });

    nextButton.addEventListener('click', () => {
        currentIndex++;
        moveNextCarousel(currentIndex);
    });

    const footer = cEl('div');
    footer.classList.add('footer');

    const learnButton = cEl('button');
    learnButton.classList.add('button', 'border-button');
    learnButton.innerHTML = '병원 서비스 로봇 배우기';
    learnButton.addEventListener('click', e => {
        navigateTo(PATH_LEARN);
    });

    const testButton = cEl('button');
    testButton.classList.add('button', 'brand-button');
    testButton.innerHTML = '자가진단 테스트 시작하기';
    testButton.addEventListener('click', e => {
        navigateTo(PATH_TEST);
    });

    footer.append(learnButton, testButton);

    homeContainer.append(carouselContainer, footer);

    let carouselAutoPlay = null;
    function startAutoPlay() {
        stopAutoPlay();
        carouselAutoPlay = setInterval(() => {
            currentIndex++;
            moveNextCarousel(currentIndex);
        }, ANIMATION_INTERVAL_TIME + ANIMATION_TIME);
    }

    function stopAutoPlay() {
        clearInterval(carouselAutoPlay);
        carouselAutoPlay = null;
    }

    carouselContainer.addEventListener('mouseenter', () => {
        stopAutoPlay();
    });
    carouselContainer.addEventListener('mouseleave', () => {
        startAutoPlay();
    });
    startAutoPlay();

    // 캐러셀 위치 조정
    function resizeEventHandler() {
        carousel.style.transform = `translateX(${(window.innerWidth - slideWidth) / 2 - slideWidth * currentIndex + 40}px)`;
    }
    function hideEventHandler() {
        if (document.hidden) {
            stopAutoPlay();
        } else {
            startAutoPlay();
        }
    }
    window.addEventListener('resize', resizeEventHandler);
    window.addEventListener('visibilitychange', hideEventHandler);

    const observer = new MutationObserver(function () {
        if (!document.querySelector('.home-container')) {
            observer.disconnect();
            stopAutoPlay();
            window.removeEventListener('resize', resizeEventHandler);
            window.removeEventListener('visibilitychange', hideEventHandler);
        }
    });

    observer.observe(parent ?? document.querySelector('.app-main'), { childList: true, subtree: true });

    return homeContainer;
}

function animateWithTransition(element, cssProperties, duration, callback) {
    element.style.transition = `transform ${duration}ms ease-in-out`;

    // CSS 속성 적용
    for (let prop in cssProperties) {
        element.style[prop] = cssProperties[prop];
    }

    // 애니메이션이 끝난 후 callback 호출
    setTimeout(() => {
        if (callback && typeof callback === 'function') {
            callback();
        }

        // transition을 제거하여 다른 애니메이션에서 설정할 수 있도록
        element.style.transition = '';
    }, duration);
}

export default Home;
